const store = {
    namespaced: true,
    actions: {
        setUserName: async function ({ commit }, data) {
            try {
                const res = await this.$axios({
                    method: 'patch',
                    url: `/api/users/change-full-name/`,
                    data: { full_name: data.full_name },
                });
            } catch (error) {
                console.dir(error);
            }
        },
        addChangeAvatar: async function ({ commit }, data) {
            try {
                const res = await this.$axios({
                    method: 'patch',
                    url: `/api/users/change-profile-image/`,
                    data: data,
                });
            } catch (error) {
                console.dir(error);
            }
        },
        deleteAvatar: async function ({ commit }, data) {
            try {
                const res = await this.$axios({
                    method: 'delete',
                    url: `/api/users/delete-profile-image/`,
                });
            } catch (error) {
                console.dir(error);
            }
        },
        changePassword: async function ({ commit, rootGetters }, data) {
            await this.$axios({
                method: 'post',
                url: '/auth/users/set_password/',
                data: {
                    current_password: data.old_password,
                    new_password: data.new_password,
                    re_password: data.re_password,
                },
                headers: {
                    Authorization: `Bearer ${this.$cookies.get('AuthToken')}`,
                },
            });
        },
        setAuthNumber: async function ({ commit }, data) {
            const res = await this.$axios({
                method: 'patch',
                url: `/api/phone/change-auth-number/`,
                data: {
                    phone_number: data.phone_number.replace(/\s/g, ''),
                    verification_code: data.verification_code,
                },
            });
        },
        addAuthNumber: async function ({ commit }, data) {
            const res = await this.$axios({
                method: 'post',
                url: `/api/phone/create-auth-number/`,
                data: {
                    phone_number: data.phone_number.replace(/\s/g, ''),
                    verification_code: data.verification_code,
                },
            });
        },
        setPhoneNumber: async function ({ commit }, data) {
            const res = await this.$axios({
                method: 'POST',
                url: `/api/phone/`,
                data: {
                    phone_number: data.phone_number.replace(/\s/g, ''),
                    verification_code: data.verification_code,
                },
            });
        },
        deletePhoneNumber: async function ({ commit }, data) {
            try {
                const res = await this.$axios({
                    method: 'DELETE',
                    url: `/api/phone/${data.id}/`,
                });
            } catch (error) {
                console.dir(error);
            }
        },
        deleteEmail: async function ({ commit }, data) {
            try {
                const res = await this.$axios({
                    method: 'DELETE',
                    url: `/api/email/${data.id}/`,
                });
            } catch (error) {
                console.dir(error);
            }
        },
        addEmail: async function ({ commit }, data) {
            try {
                const res = await this.$axios({
                    method: 'post',
                    url: `/api/email/`,
                    data: {
                        email_address: data.email,
                        verification_code: data.code,
                    },
                });
            } catch (error) {
                console.dir(error);
            }
        },
        changeEmail: async function ({ commit }, data) {
            try {
                const res = await this.$axios({
                    method: 'patch',
                    url: `/api/email/change/`,
                    data: {
                        email_address: data.email,
                        verification_code: data.code,
                    },
                });
            } catch (error) {
                console.dir(error);
            }
        },
        sendCodeToEmail: async function ({ commit }, data) {
            const res = await this.$axios({
                method: 'post',
                url: `/api/email/send-code/`,
                data: { new_email_address: data.email },
            });
        },
        sendVerificationNumberCode: async function ({ commit }, data) {
            const res = await this.$axios({
                method: 'post',
                url: `/api/phone/send-code/`,
                data: { new_phone_number: data.new_phone_number.replace(/\s/g, '') },
            });
        },
    },
};

export default store;
